<template>
    <v-dialog
        transition="dialog-top-transition"
        max-width="1300"
        v-model="isOpenDialog"
    >
        <div v-if="loadingInstallments" class="white pa-6">
            <LoadingSkeleton />
        </div>
        <v-card v-else width="100%">
            <v-tabs v-model="tabs" fixed-tabs class="pt-md-2">
                <v-tabs-slider></v-tabs-slider>
                <v-tab href="#tabs-5-1" class="primary--text">
                    <v-icon>mdi-phone</v-icon>
                    Preview
                </v-tab>
                <v-tab href="#tabs-5-2" class="primary--text">
                    <v-icon>mdi-feature-search-outline</v-icon>
                    Características
                </v-tab>
                <v-tab href="#tabs-5-3" class="primary--text">
                    <v-icon>mdi-view-list-outline</v-icon>
                    Precio por tarifa
                </v-tab>
            </v-tabs>

            <v-row>
                <v-col class="px-md-12 pt-md-5" md="12">
                    <v-row>
                        <v-col md="7">
                            <h1 class="font-weight-light">
                                {{ selectedDevice ? selectedDevice.name : '' }}
                            </h1>
                        </v-col>
                        <v-col md="3" class="pt-md-4">
                            <v-btn
                                class="align-self-center"
                                outlined
                                v-if="selectedDevice && selectedDevice.price"
                                :color="
                                    selectedDevice &&
                                    selectedDevice.devices &&
                                    selectedDevice.devices.length > 0 &&
                                    selectedDevice.devices[0].color
                                        ? selectedDevice.devices[0].color
                                        : 'primary'
                                "
                            >
                                {{
                                    selectedDevice
                                        ? 'Precio al Contado: ' +
                                          selectedDevice.price +
                                          ' €'
                                        : ''
                                }}
                                <v-icon> mdi-cash-multiple </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="2" class="pt-md-4">
                            <v-btn
                                class="align-self-center"
                                outlined
                                v-if="selectedDevice && selectedDevice.seguro"
                                :color="
                                    selectedDevice &&
                                    selectedDevice.devices &&
                                    selectedDevice.devices.length > 0 &&
                                    selectedDevice.devices[0].color
                                        ? selectedDevice.devices[0].color
                                        : 'primary'
                                "
                            >
                                {{
                                    selectedDevice && selectedDevice.seguro
                                        ? 'Seguro: ' +
                                          Math.round(
                                              selectedDevice.seguro.price * 1.21
                                          ) +
                                          ' €'
                                        : 'Sin seguro'
                                }}
                                <v-icon> mdi-cash-multiple </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                </v-col>
            </v-row>

            <v-tabs-items v-model="tabs">
                <v-tab-item value="tabs-5-1">
                    <v-card flat class="pa-md-4 ma-md-2">
                        <DevicePreview />
                    </v-card>
                </v-tab-item>
                <v-tab-item value="tabs-5-2">
                    <v-card flat class="pa-md-4 ma-md-2">
                        <DeviceSpecs />
                    </v-card>
                </v-tab-item>
                <v-tab-item value="tabs-5-3">
                    <v-card flat class="pa-md-4 ma-md-2">
                        <DeviceInstallment />
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
            <v-card-actions class="justify-end">
                <v-btn text color="red darken-3" @click="closeForm()">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import DeviceSpecs from '@/components/ComercialTeletrabajo/DeviceManagement/DeviceSpecs.vue';
import DeviceInstallment from '@/components/ComercialTeletrabajo/DeviceManagement/DeviceInstallment.vue';
import DevicePreview from '@/components/ComercialTeletrabajo/DeviceManagement/DevicePreview.vue';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import { mapState } from 'vuex';

export default {
    name: 'DeviceInfo',
    data: () => ({
        tabs: 1,
    }),
    methods: {
        closeForm() {
            // this.$store.commit('deviceManagement/selectedDevice', null);
            this.$store.commit('deviceManagement/isOpenDialog', false);
        },
        clearFields() {
            this.$store.commit('deviceManagement/selectedDevice', '');
        },
    },
    components: {
        DeviceSpecs,
        DeviceInstallment,
        DevicePreview,
        LoadingSkeleton,
    },
    computed: {
        isOpenDialog: {
            get() {
                return this.$store.state.deviceManagement.isOpenDialog;
            },
            set(val) {
                this.tabs = 1;
                this.$store.commit('deviceManagement/isOpenDialog', val);
            },
        },
        ...mapState('deviceManagement', {
            selectedDevice: (state) => state.selectedDevice,
            loadingInstallments: (state) => state.loadingInstallments,
        }),
    },
    watch: {},
};
</script>
